import { styled } from '@mui/material/styles';
import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

export const ValidationItem = styled((props: TextFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Allow only a single digit 0-9
    if (!/^\d?$/.test(value)) {
      e.preventDefault();
      e.target.value = '';
      return;
    }

    props.onChange?.(e); // forward to parent onChange handler
  };
  return (
    <TextField
      {...props}
      onChange={handleChange}
      error={props.error}
      slotProps={{ ...props.slotProps, htmlInput: { maxLength: 1 } }}
    ></TextField>
  );
})({
  width: '38px',
  height: '50%',
  padding: 0,
  margin: 0,
  borderRadius: 4,
  '& .MuiInputBase-input': {
    height: '100%',
    width: '100%',
  },
});
